import type { TemplateVersion } from '@/api/v2Client';

/** Form Templates row 8 — the version-diff keyword for the live template body. */
export const CURRENT_VERSION = 'current';

/**
 * The default "From" side of a version compare: the version just before `id`
 * (by number), or the live text when `id` is the first version.
 */
export function previousVersionId(versions: readonly TemplateVersion[], id: string): string {
  const sel = versions.find((v) => v.Id === id);
  if (!sel) return CURRENT_VERSION;
  const before = versions
    .filter((v) => v.VersionNumber < sel.VersionNumber)
    .sort((a, b) => b.VersionNumber - a.VersionNumber)[0];
  return before?.Id ?? CURRENT_VERSION;
}
